import React from 'react';
import { containers } from '@ecosystem/newron-design-system';

import { ConfigGroup, ConfigGroupValue, ConfigItem, isConfigGroup } from '../types';
import { ConfigItemElement } from './ConfigItemElement';
import { ConfigItemElementProps } from './types';

const { Accordion } = containers;

type Props = ConfigItemElementProps<ConfigGroup>;

export const groupConfigGroups = (configItems: ConfigGroupValue): (ConfigItem | ConfigGroup[])[] => {
  return configItems.reduce((acc, configItem) => {
    if (isConfigGroup(configItem)) {
      if (Array.isArray(acc[acc.length - 1])) {
        acc[acc.length - 1].push(configItem);
      } else {
        acc.push([configItem]);
      }
    } else {
      acc.push(configItem);
    }

    return acc;
  }, []);
};

function ConfigGroupElement({ configItem: configGroup, depth, index, onChange, onRequestOptions }: Readonly<Props>) {
  const reduced = groupConfigGroups(configGroup.value);

  return (
    <>
      {depth === 0 && (
        <div className="pb-3 flex flex-column gap-4 py-2" data-test-id={`l1-header-${configGroup.label}`}>
          {index > 0 && <div className="w-full bg-dark" style={{ height: '1px' }} data-test-id="l1-group-separator" />}
          <div className="text-lg	font-normal text-left">{configGroup.label}</div>
        </div>
      )}
      {reduced.map(configItem =>
        Array.isArray(configItem) ? (
          <Accordion flushAlign={true} key={configGroup.label} hoverColor="bg-medium" iconRight={true}>
            {configItem.map(groupedConfigItem => {
              return (
                <Accordion.Item
                  key={groupedConfigItem.label}
                  title={groupedConfigItem.label}
                  data-testid={`accordion-item-${groupedConfigItem.key}`}
                >
                  <ConfigItemElement
                    key={groupedConfigItem.key}
                    configItem={groupedConfigItem}
                    depth={depth + 1}
                    onChange={onChange}
                    onRequestOptions={onRequestOptions}
                  />
                </Accordion.Item>
              );
            })}
          </Accordion>
        ) : (
          <ConfigItemElement
            key={configItem.key}
            configItem={configItem}
            depth={depth + 1}
            onChange={onChange}
            onRequestOptions={onRequestOptions}
          />
        )
      )}
    </>
  );
}

export { ConfigGroupElement };
